export default __webpack_public_path__ + "static/img3-c9880e7131c54627b606c6b203423d04.png";